export const API_URL = "https://dev.machinerentals.app";
